// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGDropdownCheckmarkIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignoreQ
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  // flex: "0 0 auto",
  cursor: "pointer",
  display: "block",
  color: "#7bc243",
  marginBottom: 0
};

export default class SVGDropdownCheckmarkIcon extends PureComponent<
  ISVGDropdownCheckmarkIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        style={style}
        width="22px"
        height="22px"
        viewBox="0 0 22 22"
      >
        <path
          fill={style.color}
          d={
            "M22,1.749c0,0.235,0,0.469,0,0.704c-3.445,1.571-6.942,4.754-9.101,7.646c-0.714,0.958-1.553,1.879-2.204,2.908c-0.944,1.491-1.947,3.082-2.674,4.738c-0.235,0.536-0.482,1.038-0.703,1.547c-0.114,0.261-0.13,0.625-0.376,0.751c-0.176-0.498-1.162-1.24-1.501-1.689c-1.152-1.525-2.601-2.79-3.752-4.315C1.291,13.511,0.214,12.711,0,12.116C0.804,11.655,1.506,11,2.252,10.474c0.46-0.325,1.027-0.58,1.407-0.985c0.031,0,0.063,0,0.094,0c0.173,0.563,0.685,1.074,0.985,1.548c0.388,0.612,0.692,1.216,1.079,1.83c0.272,0.432,0.608,0.837,0.844,1.313c0.083-0.031,0.046-0.01,0.094-0.048c0.444-0.438,0.759-1.084,1.126-1.594c0.528-0.735,1.187-1.385,1.735-2.111c0.272-0.361,0.715-0.626,0.986-0.986c0.411-0.543,0.91-1.042,1.454-1.454c0.188-0.204,0.376-0.407,0.563-0.609c0.462-0.35,0.858-0.786,1.314-1.125c1.158-0.868,2.299-1.654,3.563-2.44c0.997-0.619,2.026-1.104,3.19-1.595C21.084,2.051,21.491,1.796,22,1.749z"
          }
        />
      </svg>
    );
  }
}
